<template>
  <div>
    <div class="content">
      <div class="cont-list">
        <span class="list">{{
          this.parentRoute.menuName + "-" + this.route.menuName
        }}</span>
        <span class="masge">当前共有{{ total }}条资产卡片</span>
      </div>
      <div class="header">
        <div class="left">
          <el-button v-if="tableAcl.indexOf('Add') != -1" class="btn primary" type="primary" size="small" v-preventReClick @click="handleAdd">新建资产卡片</el-button>
          <el-button :disabled="multiple" v-if="tableAcl.indexOf('Print') != -1" class="btn" size="small" v-preventReClick @click="handlePrint">
            打印卡片
          </el-button>
          <!-- <el-button
            v-if="tableAcl.indexOf('Remove') != -1"
            class="btn"
            size="small"
            :disabled="multiple"
            v-preventReClick
            @click="handleDelete"
            >删除</el-button
          > -->
          <el-badge :value="UnAssetCardsTotal ? UnAssetCardsTotal : ''" class="item" :max="99">
            <el-button class="btnD" size="small default" v-preventReClick @click="openUnAssetCards">未建卡资产</el-button>
          </el-badge>
        </div>
        <div class="right">
          <div class="search">
            <el-input type="text" v-model="query.keyWord" @keyup.enter.native="queryChange">
              <i slot="suffix" class="el-icon-search" @click="queryChange"></i>
            </el-input>
            <!-- <i class="el-icon-search padding10" v-preventReClick @click="queryChange"></i> -->
          </div>
          <span v-preventReClick @click="reset1">重置</span>
        </div>
      </div>

      <!-- <el-tabs v-model="query.category" @tab-click="handleClick" stretch>
        <el-tab-pane
          v-for="item in AssetTypeOptions"
          :key="item.id"
          :name="item.id + ''"
        >
          <template slot="label">
            <span style="margin: 0 10px"> {{ item.name }} </span>
          </template>
        </el-tab-pane>
      </el-tabs> -->

      <el-table ref="multipleTable" border row-key="id" :data="tableData" :max-height="tableHeight" style="width: 100%" @selection-change="handleSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
        <template slot="empty">
          <div class="empty-div" :style="{ height: tableHeight + 'px' }">
            <img src="../../../../assets/noData.png" width="240" height="240" />
            <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
            <div class="empty-rest" @click="reset1">恢复默认</div>
          </div>
        </template>
        <el-table-column align="center" :reserve-selection="true" type="selection" fixed width="55">
        </el-table-column>
        <el-table-column prop="no" label="资产名称" min-width="170">
          <template slot-scope="scope">
            <span>{{ scope.row.fixedAssetName }}</span><br />
            <span>{{ scope.row.fixedAssetNo }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="id" label="id" min-width="80"></el-table-column>
        <el-table-column prop="no" label="资产卡号" min-width="165"></el-table-column>
        <el-table-column prop="createdUserName" label="创建人" width="80"></el-table-column>
        <el-table-column prop="deptName" label="使用科室" width="100"></el-table-column>
        <el-table-column prop="warehouseName" label="入库库房" show-overflow-tooltip width="100"></el-table-column>
        <el-table-column prop="specName" label="规格型号" width="100"></el-table-column>
        <el-table-column prop="supplierName" label="供应商" width="100"></el-table-column>
        <el-table-column prop="amount" label="原值" width="80">
          <template slot-scope="scope">
            <span>￥{{ scope.row.amount }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="assetNetSalvage" label="净残值" width="100">
          <template slot-scope="scope">
            <span>￥{{ scope.row.assetNetSalvage }}</span>
          </template>
        </el-table-column>
        <el-table-column label="剩余使用寿命（月）" width="170">
          <template slot-scope="scope">
            <span>{{ getServiceLife(scope.row) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="资产状态" prop="stateName" width="100" align="center">
        </el-table-column>
        <el-table-column v-if="isWorkflowTable" label="审批人" width="100" align="center" prop="approverNames" />
        <el-table-column prop="statusName" label="流程状态" width="80" v-if="isWorkflowTable">
          <template slot-scope="scope">
            <approve-status :row="scope.row" :isWorkflowTable="isWorkflowTable" :options="ApproveStatusOptions" @success="getData" :tableCode="route.name"></approve-status>
          </template>
        </el-table-column>
        <el-table-column prop="operation" label="操作" width="220">
          <template slot-scope="scope">
            <el-button type="text" v-preventReClick @click="handleInfo(scope.row)" class="color-blue">查看</el-button>
            <el-button v-if="
                scope.row.status == 1 &&
                  isShowApproveButton(scope.row.approverIds)
              " type="text" v-preventReClick @click="handleApprove(scope.row)" class="margin-left20 color-blue">审核</el-button>
            <el-button v-else-if="
                scope.row.status != 1 && tableAcl.indexOf('Edit') != -1
              " type="text" v-preventReClick @click="handleUpdate(scope.row)" class="margin-left20 color-blue">编辑</el-button>
            <span v-else class="margin-left20 color-blue">&nbsp;&nbsp;-&nbsp;&nbsp;</span>
            <!-- <el-button
              v-if="tableAcl.indexOf('Remove') != -1"
              type="text"
              v-preventReClick
              @click="handleDelete(scope.row)"
              class="margin-left20 color-blue"
              >删除</el-button
            > -->

            <el-popover placement="bottom" width="660" trigger="click" v-model="scope.row.visible" style="line-height:30px">
              <div>
                <el-button class="btn operation" v-preventReClick @click="scope.row.visible = false">转科</el-button>
                <el-button class="btn operation" v-preventReClick @click="scope.row.visible = false">外调</el-button>
                <el-button class="btn operation" v-preventReClick @click="scope.row.visible = false">退货</el-button>
                <el-button class="btn operation" v-preventReClick @click="scope.row.visible = false">清查</el-button>
                <el-button class="btn operation" v-preventReClick @click="scope.row.visible = false">处置</el-button>
                <el-button class="btn operation" v-preventReClick @click="scope.row.visible = false">养护</el-button><br />
                <div style="height:10px"></div>
                <el-button class="btn operation" v-preventReClick @click="scope.row.visible = false">故障报修</el-button>
                <el-button class="btn operation" v-preventReClick @click="scope.row.visible = false">计量</el-button>
                <el-button class="btn operation" v-preventReClick @click="scope.row.visible = false">保养</el-button>
                <el-button class="btn operation" v-preventReClick @click="scope.row.visible = false">资产卡片</el-button>
                <el-button class="btn operation" v-preventReClick @click="scope.row.visible = false">维修验收</el-button>
              </div>

              <el-button type="text" slot="reference" class="margin-left20 color-blue">流程申请</el-button>
            </el-popover>
            <!-- <operation></operation> -->
          </template>
        </el-table-column>
      </el-table>

      <!-- <info :show="showInfo" :id="id" @handleClose="closeInfo"></info> -->
    </div>
    <div class="pagination">
      <el-pagination background layout="sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="query.pageSize" @size-change="handleSizeChange" :current-page="query.pageIndex" :total="total" @current-change="changePage">
      </el-pagination>
    </div>
    <el-dialog title="未建卡资产" :visible.sync="UnAssetCardsDialogVisible" :center="true" width="600px" :before-close="
        () => {
          UnAssetCardsDialogVisible = false;
        }
      " :close-on-click-modal="false" :destroy-on-close="true">
      <div class="dia-header">
        <div class="search">
          <input class="search-input" type="text" v-model="UnAssetCardsKeyWord" @change="queryNoCard" placeholder="输入资产编号/名称/规格型号进行搜索" />
          <i class="el-icon-search padding10" v-preventReClick @click="queryNoCard"></i>
        </div>
        <span v-preventReClick @click="reset1">重置</span>
      </div>
      <div class="dia-content">
        <el-radio-group class="expand-table-group" v-model="selectRow">
          <template v-for="item in UnAssetCardsData">
            <ExpandTable :key="item.id" :pid="item.id + ''" :isExpand="true" :columns="UnAssetCardsColumns" :data="item.details ? item.details : []" :title="item.fixedAssetNo + ' ' + item.fixedAssetName" @selectChange="selectChange"></ExpandTable>
          </template>
        </el-radio-group>
      </div>
      <div slot="footer" class="dialog-footer" style="">
        <el-button class="btn" size="small" v-preventReClick @click="
            () => {
              UnAssetCardsDialogVisible = false;
            }
          ">取 消</el-button>
        <el-button class="btn primary" type="primary" size="small" v-preventReClick @click="createCard">去建卡</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { RemoveAssetCards, GetAssetCards, GetUnAssetCards } from "@/api";
import GetDataMixin from "@/mixin/getData-mixin.js";
// import Info from './info';
import { AssetTypeOptions } from "@/enum";
import ExpandTable from "@/components/expand-table";
import BaseListMixin from '@/mixin/baseList-mixin.js'

export default {
  mixins: [GetDataMixin, BaseListMixin],
  components: {
    // Info
    ExpandTable,
  },
  data () {
    return {
      GetDatasAction: GetAssetCards,
      RemoveAction: RemoveAssetCards,
      editPath: 'card-edit',
      // 查询条件
      query: {
        keyWord: "",
        pageSize: 10,
        pageIndex: 1,
        category: "1",
      },

      AssetTypeOptions: AssetTypeOptions,
      // ApproveStatusOptions: ApproveStatusOptions,
      visible: false,
      UnAssetCardsData: [],
      UnAssetCardsTotal: 0,
      UnAssetCardsKeyWord: "",
      UnAssetCardsDialogVisible: false,
      UnAssetCardsColumns: [
        {
          label: "品牌",
          prop: "brandName",
          width: "100",
          align: "left",
          tooltip: true,
        },
        {
          label: "供应商",
          prop: "supplierName",
          width: "100",
          align: "left",
          tooltip: true,
        },
        {
          label: "生产厂家",
          prop: "manufacturerName",
          width: "100",
          align: "left",
          tooltip: true,
        },
        {
          label: "单价",
          prop: "price",
          width: "160",
          align: "left",
          formatter: this.toDecimal4,
          tooltip: true,
        },
        {
          label: "数量",
          prop: "number",
          width: "100",
          align: "left",
          formatter: this.toDecimal2,
        },
        {
          label: "未建卡数量",
          prop: "unCardNumber",
          width: "100",
          align: "left",
          formatter: this.toDecimal2,
        },
        {
          label: "注册证号",
          prop: "certNo",
          width: "100",
          align: "left",
          tooltip: true,
        },
        {
          label: "库房",
          prop: "warehouseName",
          width: "100",
          align: "left",
          tooltip: true,
        },
        {
          label: "科室",
          prop: "deptName",
          width: "100",
          align: "left",
          tooltip: true,
        },
        {
          label: "产地类型",
          prop: "productionPlaceName",
          width: "100",
          align: "left",
          tooltip: true,
        },
        {
          label: "产品来源",
          prop: "assetSourceName",
          width: "100",
          align: "left",
          tooltip: true,
        },
        {
          label: "货位",
          prop: "locationName",
          width: "100",
          align: "left",
          tooltip: true,
        },
        {
          label: "货位",
          prop: "locationName",
          width: "100",
          align: "left",
          tooltip: true,
        },
        {
          label: "包装说明",
          prop: "packDesc",
          width: "100",
          align: "left",
          tooltip: true,
        },
        {
          label: "状态",
          prop: "stateName",
          width: "100",
          align: "left",
          tooltip: true,
        },
      ],

      selectRow: null,
    };
  },
  created () {
    let params = this.$route.params;
    if (params.category) {
      this.query.category = params.category;
    }
  },
  methods: {
    refenceQuery () {
      this.query = {
        keyWord: "",
        pageSize: 10,
        pageIndex: 1,
        category: "1",
      };
      if (this.$refs["selectFilter"]) {
        this.$refs["selectFilter"].resetQuery();
      }
    },
    // // 获取列表
    // getData () {
    //   GetAssetCards(this.query).then((res) => {
    //     this.tableData = res.returnData.data;
    //     this.total = res.returnData.totalCount;
    //   });
    // },
    // // 查看信息
    // handleInfo (row) {
    //   this.$router.push("/card-edit?formMode=0&id=" + row.id);
    // },
    // // 新建
    // handleAdd () {
    //   this.$router.push(
    //     "/card-edit?formMode=1&category=" + this.query.category
    //   );
    // },
    // // 编辑
    // handleUpdate (row) {
    //   this.$router.push("/card-edit?formMode=2&id=" + row.id);
    // },
    // // 审批
    // handleApprove (row) {
    //   this.$router.push("/card-edit?formMode=3&id=" + row.id);
    // },
    // // 改变当前页
    // changePage (val) {
    //   this.$set(this.query, "pageIndex", val);
    //   this.getData();
    // },
    // handleSizeChange (val) {
    //   this.$set(this.query, "pageSize", val);
    //   this.getData();
    // },
    // // 删除部门
    // handleDelete (row) {
    //   const ids = row && row.id ? [row.id] : this.ids;

    //   this.$my_confirm("此操作将删除数据，是否继续？", "提示", {
    //     type: "warning",
    //   })
    //     .then(() => {
    //       return RemoveAssetCards({ ids });
    //     })
    //     .then(() => {
    //       this.$my_message(`操作成功！`, "success");
    //       this.getData();
    //     })
    //     .catch(() => { });
    // },
    /**
     * 查看未建卡资产
     */
    openUnAssetCards () {
      this.UnAssetCardsKeyWord = "";
      this.UnAssetCardsDialogVisible = true;
      this.queryNoCard();
    },
    /**
     * 查询未建卡资产
     */
    queryNoCard () {
      GetUnAssetCards({
        pageSize: 10000,
        pageIndex: 1,
        keyWord: this.UnAssetCardsKeyWord,
      }).then((res) => {
        this.UnAssetCardsData = res.returnData.data;
        this.UnAssetCardsTotal = res.returnData.totalCount;
      });
    },
    // 重置
    reset1 () {
      this.query = {
        keyWord: "",
        pageSize: 10,
        pageIndex: 1,
        category: "1",
        orgCode :sessionStorage.getItem('orgId')
      };
      if (this.$refs["selectFilter"]) {
        this.$refs["selectFilter"].resetQuery();
      }
      this.ids = []
      this.multipleSelection = []
      this.multiple = true;

      if (this.$refs.multipleTable) {
        this.$refs.multipleTable.clearSelection()
      }
      this.getData();
    },
    // queryChange () {
    //   this.$set(this.query, "pageIndex", 1);
    //   this.getData();
    // },
    handleClick (tab) {
      // this.query.type =
      this.$set(this.query, "pageIndex", 1);
      this.getData();
    },
    // 打印
    handlePrint () {
      this.RoutePushName("AssetCardPrintPreview", {
        ids: this.ids.join(","),
        title: "资产卡片",
      });
    },

    // 剩余使用寿命
    getServiceLife (row) {
      let total = row.serviceLifeMonth || 0;
      let deduct = row.depreciatedYear || 0;

      return total - deduct < 0 ? 0 : total - deduct;
    },
    selectChange (item) {
      window.console.log(this.selectRow);
    },
    createCard () {
      this.UnAssetCardsDialogVisible = false;
      this.$router.push({
        path: "card-edit",
        query: {
          editMode: 1,
          category: 1,
          assetStockId: this.selectRow.id,
          formMode: 1,
        },
      });
    },
  },
  mounted () {
    this.queryNoCard();
  },
  /** 生命周期 - 创建完成（可以访问当前this实例） */
  created () {
    // this.getData();
  },
};
</script>

<style lang="scss" scoped>
.el-tabs {
  width: 200px;
  margin-bottom: 10px;
}
.dia-header {
  display: flex;
  height: 40px;
  align-items: center;
  width: 100%;
  .search {
    border: 1px solid #eeeeee;
    border-radius: 0px 0px 0px 0px;
    width: 500px;
    .search-input {
      width: 450px;
      height: 32px;
      background: #ffffff;
      opacity: 1;
      border: none;
      padding-left: 10px;
      outline: none;
    }
    .search-input:focus {
      border: none !important;
    }
    i {
      cursor: pointer;
    }
  }
  span {
    cursor: pointer;
    margin-left: 20px;
  }
}
.dia-content {
  height: 500px;
  overflow: hidden;
  overflow-y: auto;
  padding: 0 20px 0 0;
}
.expand-table-group {
  display: block;
  font-size: 14px;
}
</style>
